var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSupport = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,0A9,9,0,0,0,1.392,13.806L.3,17.9l3.973-1.242A9,9,0,1,0,9,0ZM9,16.875a8.411,8.411,0,0,1-4.572-1.444l-2.515.786c.036-.134.652-2.447.693-2.6A7.627,7.627,0,0,1,1.125,9,7.875,7.875,0,1,1,9,16.875Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "translate(8.051 11.951)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.233,4.453A2.679,2.679,0,0,0,6.395,7.34H7.744c0-1.025.415-1.762,1.431-1.762a1.242,1.242,0,0,1,1.159,1.313c0,1.046-.779,1.206-1.366,1.922A2.991,2.991,0,0,0,8.453,10.8H9.73a2.179,2.179,0,0,1,1.041-2,2.236,2.236,0,0,0,1.04-1.963A2.359,2.359,0,0,0,9.233,4.453Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSupport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/support.45d45706eb8525911c248d86e68ebda4.svg";